'use strict';

var jsxRuntime = require('react/jsx-runtime');

function Show({
  when,
  fallback = null,
  children
}) {
  const condition = when;
  if (condition) {
    return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children: typeof children === "function" ? children(condition) : children });
  }
  return fallback;
}

module.exports = Show;
//# sourceMappingURL=index.cjs.map
